module.exports = __webpack_public_path__ + "static/img/deletar_noticia_page.7dc6a10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deletar_noticia_page.jpg
// module id = ze1v
// module chunks = 1